<ng-container *ngIf="stateView === 'INIT'; else appContent">
  <div class="loading-container">
    <div class="loading-bar"></div>
  </div>
</ng-container>
<ng-template #appContent>
  <div
    *ngIf="stateView === 'APP'"
    class="w-full mx-auto flex flex-col bg-gray-50"
  >
    <!-- Virtual header has the same height with <header>, to support UI flows -->
    <header
      class="min-h-[3.125rem] max-h-[3.125rem] w-full bg-transparent border-transparent select-none"
    ></header>
    <!-- Virtual header -->

    <!-- HEADER, with proper z-index for another elements to pop up: dialog, tooltip, ... -->
    <!-- <app-header
      class="fixed z-20 h-[3.125rem] min-w-[480px] bg-white shadow-sm w-full"
      [isSmallScreen]="isSmallScreen"
      [user]="user"
      (openSidebar)="sidebarVisible = $event"
    ></app-header> -->
    <lib-header
      class="fixed top-0 z-[51] w-[100vw] bg-blue-600"
      [isShowMenu]="false"
      [visibleSearch]="false"
      [userInfo]="user"
      [myCoin]="0"
      [visibleShopingCart]="false"
      [isAdmin]="true"
      [isShowMarketPlace]="true"
      [visibleMegaMenu]="false"
      [visibleNoti]="false"
      [environment]="env"
      [currentPage]="'admin'"
      [currentTheme]="'darkTheme'"
      [isFullWidth]="true"
      (changeMarketplace)="changeMarketplace($event)"
      (changeLanguageMarketplace)="changeLanguage($event)"
      [moderatorType]="'CAR_MODULE_ADMIN '"
      [banner]="'Car Admin'"
    ></lib-header>

    <!-- Body -->
    <div
      class="w-screen h-auto md:min-w-[480px] flex flex-grow mx-auto relative pt-6 md:pt-3"
    >
      <i
        *ngIf="isSmallScreen"
        class="pi pi-bars p-1 cursor-pointer hover:text-blue-500 text-gray-700 top-5 left-3 absolute"
        (click)="sidebarVisible = true"
      ></i>
      <!-- SIDEBAR -->
      <app-sidebar [(sidebarVisible)]="sidebarVisible"></app-sidebar>

      <!-- CONTENT -->
      <div class="flex-1 h-full p-6 overflow-clip">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</ng-template>
